/** Route paths in one place — no string literals sprinkled through the UI. */
export const paths = {
  login: '/login',
  invitations: '/invitations',
  invitation: (token: string) => `/invitations/${token}`,
  pipeline: '/pipeline',
  calls: '/calls',
  customers: '/customers',
  customerDetail: (customerId: string) => `/customers/${customerId}`,
  scheduler: '/scheduler',
  compliance: '/compliance',
  customerCompliance: (customerId: string) =>
    `/compliance?customer=${encodeURIComponent(customerId)}`,
  appointmentCompliance: (customerId: string, appointmentId: string) =>
    `/compliance?customer=${encodeURIComponent(customerId)}&appointment=${encodeURIComponent(appointmentId)}&check=1`,
  contracts: '/contracts',
  settings: '/settings',
  admin: '/admin',
  adminProducts: '/admin/ablefy-products',
} as const

/** Whether a path belongs to the platform admin's area rather than a Standort's workspace. */
export function isPlatformPath(path: string): boolean {
  return path === paths.admin || path.startsWith(`${paths.admin}/`)
}
